import { PropsWithChildren, useRef } from 'react';

import { initializeStore, Provider, Store, StoreType } from './stores';

export default function StoreProvider({
  children,
  ...props
}: PropsWithChildren<Store>) {
  const storeRef = useRef<StoreType>();

  if (!storeRef.current) {
    storeRef.current = initializeStore(props);
  }

  return <Provider value={storeRef.current}>{children}</Provider>;
}
